const Faq = () => {
	const faqGroups = document.querySelectorAll(".faq__wrapper-right-items");

	if (faqGroups.length > 0) {
		faqGroups.forEach(function (faqGroup) {
			const faqEntries = faqGroup.querySelectorAll(
				".faq__wrapper-right-items-item"
			);

			faqEntries.forEach(function (faqEntry) {
				const faqQuestion = faqEntry.querySelector(".faq__wrapper-right-items-item-question");
				const faqAnswer = faqEntry.querySelector(".faq__wrapper-right-items-item-answer");

				if (faqQuestion && faqAnswer) {
					faqQuestion.addEventListener("click", function () {
						const isActive = faqEntry.classList.contains("active");

						faqEntries.forEach(function (entry) {
							entry.classList.remove("active");
							const entryAnswer = entry.querySelector(".faq__wrapper-right-items-item-answer");
                            
							if (entryAnswer) {
								entryAnswer.style.maxHeight = "0px";
							}
						});

						if (!isActive) {
							faqEntry.classList.add("active");
							faqAnswer.style.maxHeight = faqAnswer.scrollHeight + "px";
						}
					});
				}
			});
		});
	}
};

export default Faq;
